import { create } from 'zustand';

// Iframe 상태 타입 정의
interface IframeState {
  isOpen: boolean;
  url: string;
  isAutoOpened: boolean; // 자동으로 열린 상태인지 구분
  iframeWidth: number; // iframe 너비 (퍼센트)
  isFullscreen: boolean; // 전체화면 상태
  currentTutorialStep: number | null; // 현재 튜토리얼 단계
}

// Iframe 액션 타입 정의
interface IframeActions {
  toggleIframe: () => void;
  setIframeUrl: (url: string) => void;
  openIframe: (url: string) => void;
  closeIframe: () => void;
  openDefaultIframe: (url: string) => void; // 기본 iframe 열기 (자동 상태)
  setIframeWidth: (width: number) => void; // iframe 너비 설정
  setIsFullscreen: (isFullscreen: boolean) => void; // 전체화면 설정
  setCurrentTutorialStep: (step: number | null) => void; // 튜토리얼 단계 설정
}

/**
 * @author 
 * @date 2025.10.28
 * @description Iframe 상태 관리 스토어
 */
export const useIframeStore = create<IframeState & IframeActions>((set) => ({
  isOpen: false,
  url: '',
  isAutoOpened: false,
  iframeWidth: 65,
  isFullscreen: false,
  currentTutorialStep: null,

  toggleIframe: () => set((state) => ({ isOpen: !state.isOpen })),
  
  setIframeUrl: (url) => set({ url }),
  
  openIframe: (url) => set({ isOpen: true, url, isAutoOpened: false }),
  
  closeIframe: () => set({ isOpen: false, url: '', isAutoOpened: false }),
  
  openDefaultIframe: (url) => set({ isOpen: true, url, isAutoOpened: true }),
  
  setIframeWidth: (width) => set({ iframeWidth: width }),
  
  setIsFullscreen: (isFullscreen) => set({ isFullscreen }),
  
  setCurrentTutorialStep: (step) => set({ currentTutorialStep: step }),
}));